import { remark } from "remark";
import remarkHtml from "remark-html";
import remarkGfm from "remark-gfm";
import { visit } from "unist-util-visit";

import { handleError } from "../../../utils/handleError";

const remarkInsertEmptyParagraphs = () => {
  return (tree) => {
    const emptyParagraphsToInsert = [];

    visit(tree, (node, index, parent) => {
      if (parent && index < parent.children.length - 1) {
        const nextNode = parent.children[index + 1];

        // Check if both nodes have position information
        if (!node.position || !nextNode.position) {
          return;
        }

        const currentEnd = node.position.end;
        const nextStart = nextNode.position.start;

        // Check if there are exactly two newlines between nodes
        if (
          nextStart &&
          currentEnd &&
          nextStart.line &&
          currentEnd.line &&
          nextStart.line - currentEnd.line === 2 &&
          (node.type === "heading" ||
            nextNode.type === "heading" ||
            node.type === "paragraph" ||
            nextNode.type === "paragraph")
        ) {
          emptyParagraphsToInsert.push({
            parent,
            index: index + 1,
            node: {
              type: "paragraph",
              children: [],
              position: {
                start: {
                  line: currentEnd.line + 1,
                  column: 1,
                  offset: currentEnd.offset ? currentEnd.offset + 1 : 0,
                },
                end: {
                  line: nextStart.line - 1,
                  column: 1,
                  offset: nextStart.offset ? nextStart.offset - 1 : 0,
                },
              },
            },
          });
        }
      }
    });

    emptyParagraphsToInsert.reverse().forEach(({ parent, index, node }) => {
      parent.children.splice(index, 0, node);
    });
  };
};

const splitMarkdownAndHtml = (inputString) => {
  try {
    return [inputString];
  } catch (error) {
    console.error(error);
    return [inputString];
  }
};

const convertMarkdownStringToHtmlString = async (markdownString) => {
  try {
    const htmlContent = (
      await remark()
        .use(remarkInsertEmptyParagraphs)
        .use(remarkGfm)
        .use(remarkHtml)
        .process(markdownString)
    ).toString();

    return htmlContent.toString();
  } catch (error) {
    handleError({
      error,
      location: "convertMarkdownStringToHtmlString",
    });
  }
};

const stringIsHtmlString = (inputString) => {
  try {
    return inputString.startsWith("<") || inputString.includes("</");
  } catch (error) {
    handleError({
      error,
      location: "checkIfStringIsHtml",
    });
  }
};

const convertStringToHtmlString = async (inputString, qid) => {
  try {
    // Preserve <br> tags as they are valid inline HTML within Markdown.
    const brPlaceholder = "BR_PLACEHOLDER";
    inputString = inputString.replace(/<br\s*\/?>/g, brPlaceholder);

    const substrings = splitMarkdownAndHtml(inputString);
    let htmlContent = "";
    for (const substring of substrings) {
      if (stringIsHtmlString(substring)) {
        htmlContent += substring;
      } else {
        let convertedHtml = await convertMarkdownStringToHtmlString(substring);
        htmlContent += convertedHtml;
      }
    }

    htmlContent = htmlContent.replace(new RegExp(brPlaceholder, "g"), "<br>");
    return htmlContent;
  } catch (error) {
    handleError({
      error,
      location: "convertStringToHtmlString",
    });
  }
};

export {
  convertMarkdownStringToHtmlString,
  convertStringToHtmlString,
  stringIsHtmlString,
  splitMarkdownAndHtml,
};
